import { memo, splitProps } from '../helpers.js';
import { createRecipe, mergeRecipes } from './create-recipe.js';

const richTextFn = /* @__PURE__ */ createRecipe('richText', {
  "style": "default"
}, [])

const richTextVariantMap = {
  "style": [
    "default",
    "custom"
  ]
}

const richTextVariantKeys = Object.keys(richTextVariantMap)

export const richText = /* @__PURE__ */ Object.assign(memo(richTextFn.recipeFn), {
  __recipe__: true,
  __name__: 'richText',
  __getCompoundVariantCss__: richTextFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: richTextVariantKeys,
  variantMap: richTextVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, richTextVariantKeys)
  },
  getVariantProps: richTextFn.getVariantProps,
})